<highcharts-chart
  *ngIf="highcharts"
  [Highcharts]="highcharts"
  [options]="chartOptions"
  class="distribution-chart-view"
></highcharts-chart>
